import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData, getTandC} from '../utils/endpoints'
import { Container } from 'react-bootstrap';
import Loading from './components/loading';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Header from './components/header';
import Footer from './components/footer';
import { Helmet } from 'react-helmet';
import InnerContent from './components/innerContent';

const TermsConditions = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const [tandCData, settandCData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const tandCData = await getTandC();
            settandCData(tandCData);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Booking Disclaimer || Statue of Belief || Worlds tallest shiva Statue</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
          <Container>
          <ul>
                <li><a href="/">Home</a></li>
                <li>Booking Disclaimer</li>
            </ul>
            <h1>Booking Disclaimer</h1>
          </Container>
        </section>
        <Container className='pt-5'>
        <InnerContent compData={tandCData}/>
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default TermsConditions;